export default __webpack_public_path__ + "static/iCARE-Substances-12353a5963c79413eb40855c5fc8dcb8.png";